const animationDuration = 1200;
const frameDuration = 800 / 60;
const totalFrames = Math.round(animationDuration / frameDuration);
const easeOutQuad = t => t * (2 - t);

const animateCountUp = el => {
  let frame = 0;
  const countTo = parseFloat(el.innerHTML.replace(',', '.'));

  const counter = setInterval(() => {
    frame++;
    const progress = easeOutQuad(frame / totalFrames);
    const currentCount = countTo * progress;

    if (parseFloat(el.innerHTML, 10) !== currentCount) {
      if (Number.isInteger(countTo)) {
        el.innerHTML = Math.round(currentCount);
      } else {
        el.innerHTML = currentCount.toFixed(2).replace('.', ',');
      }
    }

    if (frame === totalFrames) {
      clearInterval(counter);
    }
  }, frameDuration);
};

const runCountUp = () => {
  const numbers = document.querySelectorAll('.facts__number-inner');

  setTimeout(() => {
    numbers.forEach(animateCountUp);
  }, 950);
};

const callback = function (entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting === true) {
      entry.target.classList.add('visible');
      runCountUp();

      observer.unobserve(entry.target);
    }
  });
};

const options = {
  threshold: 0.5,
};

const targets = document.querySelectorAll('.facts');

targets.length &&
  targets.forEach(target => {
    const observer = new IntersectionObserver(callback, options);
    observer.observe(target);
  });
